module.exports = __webpack_public_path__ + "img/footer-7.ac74a98f.gif";